const comments = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20soft%20warm%20peach%20background%20and%20subtle%20circle%20shape%2C%20clean%20modern%20design%20no%20face&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '桃花视频真的太方便了！红桃视频、樱桃视频、茄子视频、糖心视频的内容一个站就能看全，追剧再也不用切换好几个平台了。画质高清，加载速度也快，强烈推荐！',
    time: '2 小时前',
    likes: 128,
  },
  {
    name: '电影爱好者小李',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20soft%20coral%20background%20and%20subtle%20geometric%20shape%2C%20clean%20modern%20design%20no%20face&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '每天晚上躺床上用手机看，一点都不卡。高清全集完全免费，这个体验真的没话说。已经推荐给身边所有追剧的朋友了！',
    time: '5 小时前',
    likes: 96,
  },
  {
    name: '综艺控小张',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20soft%20amber%20background%20and%20subtle%20round%20shape%2C%20clean%20modern%20design%20no%20face&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '之前为了看综艺要装好多 App，现在有了桃花视频，一个网站搞定所有。更新速度也快，基本上电视播出后没多久就能在这看到了。',
    time: '8 小时前',
    likes: 75,
  },
  {
    name: '动漫粉小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20soft%20rose%20background%20and%20subtle%20oval%20shape%2C%20clean%20modern%20design%20no%20face&width=80&height=80&seq=avatar-04&orientation=squarish',
    text: '茄子视频的新番动漫在这里更新超快！清晰度也很高，而且完全免费不用注册，对于我们学生党来说太友好了。',
    time: '12 小时前',
    likes: 63,
  },
  {
    name: '资深剧迷老刘',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20soft%20terracotta%20background%20and%20subtle%20square%20shape%2C%20clean%20modern%20design%20no%20face&width=80&height=80&seq=avatar-05&orientation=squarish',
    text: '用了快半年了，桃花视频的资源真的是越来越全。榴莲视频、桃子视频的内容也能在这找到，一站式观影体验太香了。希望一直保持这样的更新速度！',
    time: '1 天前',
    likes: 142,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">观众热评</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">来自真实用户的使用体验分享</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.slice(0, 3).map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-9 h-9 rounded-full object-cover flex-shrink-0 bg-background-200"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {comments.slice(3, 5).map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-9 h-9 rounded-full object-cover flex-shrink-0 bg-background-200"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}